import React from "react";
import Image from "react-bootstrap/Image";
import config from "../../../config";
import LazyLoad from "react-lazyload";

const SellBanner = ({mobile}) => {
    return (

        <LazyLoad height={600} offset={100} once={true}>
            <div className="sell-banner"
                 role="banner"
            >
                <div className="sell-banner__title">Sell your once-loved</div>
                <div className="sell-banner__text">
                    If you're over it, sell it to Rebag and use the funds on your next luxury purchase
                </div>
                <a
                    href={`${config.host_rebag}/sell-now/`}
                    className="sell-banner__cta rbg-btn-ghost"
                >
                    Start Selling
                </a>
                <Image
                    className="sell-banner__background-image"
                    alt="Sell your once-loved"
                    src={`${config.MEDIA_URL}/img/sell-banner-${mobile ? 'mobile' : 'desktop'}.png`}
                    width={mobile ? 272 : 1223}
                    height={mobile ? 118 : 119}
                />
            </div>
        </LazyLoad>
    )
};

export default SellBanner;